import { FindHtmlTags, GenerateHtmlVersionOfTag, ConvertHtmlToTags } from "./TagHelper";

/**
 * @returns Text ready to be sent to Middleware
 * @param text - takes text with tags written as img and having all the html mess
 */
export function HTMLToXLIF(text) {

    if(text === null || text === undefined || text.length === 0) return "";    

    let s = CleanHtmlExceptOfImages(text);
    s = TranslateHtmlCharacters(s);
    s = TranslateProblematicCharactersToXMLCharacters(s);
    s = ConvertHtmlToTags(s);
    return s;
}

export function CheckIfTextIsEmpty(text) {
    if(text === null || text === undefined || text.length === 0) return true;
    let s = CleanHtmlExceptOfImages(text);
    if(s.length === 0) return true;
    s = TranslateHtmlCharacters(s);
    if(s.length === 0) return true;
    s = s.replace(" ", "");
    return s.length === 0;
}

/**
 * Takes text with <br /> <div>something</div> and other tags and removes them except of images that encodes Xlif tags
 * (Images that does not encode XLIFF tags are removed)
 * @param text 
 */
export function CleanHtmlExceptOfImages(text) {
    
    if(text === null || text === undefined || text.length === 0) return "";

    return text.replace(/<[^>\s][^>]+>?/gm, (tag) => {
        let tags = FindHtmlTags(tag)
            .filter(x=>x.Type === "bpt" || x.Type === "ept" || x.Type === "ph");

        if(tags.length === 0 ) return "";
        return tags
            .map(x=>GenerateHtmlVersionOfTag(x.Type, x.Value))
            .reduce((previous, current) => previous + current);
    });
}

/**
 * Takes string with &nbsp; (expect of &lt; $gt;) and so on and changes them to Unicode
 * @param text 
 */
export function TranslateHtmlCharacters(text){

    if(text === null || text === undefined || text.length === 0) return "";

    let span = document.createElement('span');
    let toReturn = text.replace(/&[^\s;]+;/gi, (character) => {
        switch(character){
            case "&lt;":
            case "&gt;":
            case "&amp;":
            case "&quot;":
            // case "&apos;":
                return character;
        }
        span.innerHTML = character;
        let c = span.textContent || span.innerText;
        return c;
    });
    return toReturn;
    
}

/**   
 * Replaces all the characters <>"'&  to  &lt; (<), &amp; (&), &gt; (>), &quot; ("), and //&apos; (')
 * 
 * @param text - tags must be img (no bpt, ept, ph yet)
 */
export function TranslateProblematicCharactersToXMLCharacters(text) {

    if(text === null || text === undefined || text.length === 0) return "";
    
    function rc(t){
        let s = t.replace(/&[^\s]*/, (character) => {
                //if character ends on ;, then it is some html character
                //and has to be left alone in peace. Otherwise, change first
                //character (which is &) to &amp;
                if(character.indexOf(';') > -1) return character
                else return character.replace(/&/gm, "&amp;");
            });
        s = s.replace(/</gm, "&lt;");
        s = s.replace(/>/gm, "&gt;");
        s = s.replace(/"/gm, "&quot;");
        // s = s.replace(/'/gm, "&apos;");
        return s;
    }
    
    let tagsInImage = text.match(/<img\s[^>]*>/gm);
   
     
    if(tagsInImage === null) return rc(text);
    else{
        let toReturn = "";
        let toDivide = text;
        tagsInImage.forEach(x=> {
            try {
                let parts = toDivide.split(x);
                toReturn += rc(parts[0]);
                toReturn += x;
                toDivide = parts[1];
            } catch(e) {
                
            }
        });
        if(toDivide===undefined) return rc(text);
        toReturn += rc(toDivide);
        return toReturn;
    }
}